import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, EMPTY, finalize, map, tap } from 'rxjs';

import { Activity } from 'src/app/model/Avtivity';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

export type ConfirmationState =
  | 'CONFIRMED'
  | 'ALREADY_CONFIRMED'
  | 'CLOSED'
  | 'ERROR';

type ViewState =
  | 'loading'
  | 'confirmed'
  | 'already-confirmed'
  | 'closed'
  | 'error';

export interface ConfirmationResponse {
  state: ConfirmationState;
  activityName: string | null;
  activityDate: string | null;
  activityHours: string | null;
  activityAddress: string | null;
  beneficiaryFirstName: string | null;
  beneficiaryLastName: string | null;
  errorCode: string | null;
}
@Component({
  selector: 'app-bootcamp-confirmation',
  templateUrl: './bootcamp-confirmation.component.html',
  styleUrls: ['./bootcamp-confirmation.component.css'],
})
export class BootcampConfirmationComponent implements OnInit {
  idActivity!: number;
  activity!: Activity;
  showSpinner = true;
  iuf!: string;
  confirmed: boolean = false;

  viewState: ViewState = 'loading';
  data: ConfirmationResponse | null = null;

  constructor(
    private route: ActivatedRoute,
    private service: AuthService,
    private spinnerService: SpinnerServiceService,
  ) {
    this.spinnerService.showSpinner();
    this.idActivity = +this.route.snapshot.params['idActivity'];
    this.iuf = this.route.snapshot.params['iuf'];

    console.log('idActivity:', this.idActivity);
  }

  ngOnInit(): void {
    console.log('ngOnInit called');
    this.confirmParticipation();
  }
  private confirmParticipation() {
  this.service
    .confirmActivityParticipation(this.iuf, this.idActivity)
    .pipe(
      tap((confirmation: ConfirmationResponse) => {
        console.log('Confirmation response:', confirmation);
        this.data = confirmation;
        this.viewState = this.mapState(confirmation.state);
      }),
      catchError((err: HttpErrorResponse) => {
        this.viewState = 'error';
        this.data = (err.error as ConfirmationResponse) ?? null;
        return EMPTY;
      }),
      finalize(() => {
        this.showSpinner = false;
        this.spinnerService.hideSpinner();
      })
    )
    .subscribe();
}

  private mapState(state: ConfirmationState): ViewState {
    switch (state) {
      case 'CONFIRMED':
        return 'confirmed';
      case 'ALREADY_CONFIRMED':
        return 'already-confirmed';
      case 'CLOSED':
        return 'closed';
      default:
        return 'error';
    }
  }

  // private confirmParticipation() {
  //   this.service
  //     .confirmActivityParticipation(this.iuf, this.idActivity)
  //     .pipe(
  //       tap((response:CustomResponse) => {
  //         console.log('Confirmation response:', response);
  //         if (response && response.status == 200) {
  //           // response.object may be typed as {} — coerce to any to access 'participated'
  //           this.confirmed = Boolean((response.object as any)?.participated);
  //           this.activity = (response.object as any)?.activity;
  //           this.showSpinner = false;
  //         this.spinnerService.hideSpinner();
  //         }
  //       }),
  //     )
  //     .subscribe();
  // }
}
